export const EMPLOYEES_PATH = '/employees';
export const CUSTOMERS_PATH = '/administration/customers';
export const SOLUTION_PARTNERS_PATH = '/administration/solution-partners';
export const PRODUCT_PATH = '/administration/product';
export const HEALTH_INSURER_PATH = '/administration/health-insurer';
export const REGISTRATION_PERIODS_SEGMENT = 'registration-periods-v2';

export function getEmployeeLink(employeeId: string): string {
    return `${EMPLOYEES_PATH}/${employeeId}`;
}

export function getEmployeeCaseLink(employeeId: string, caseId: string): string {
    return `${EMPLOYEES_PATH}/${employeeId}/case/${caseId}`;
}

export function getCustomerLink(companyId: string): string {
    return `${CUSTOMERS_PATH}/${companyId}`;
}

export function getSolutionPartnerLink(companyId: string): string {
    return `${SOLUTION_PARTNERS_PATH}/${companyId}`;
}

export function getProductLink(productId: string): string {
    return `${PRODUCT_PATH}/${productId}`;
}

export function getHealthInsurerLink(healthInsurerId: string): string {
    return `${HEALTH_INSURER_PATH}/${healthInsurerId}`;
}

export function getRegistrationPeriodsLink(companyId: string): string {
    return `${getCustomerLink(companyId)}/${REGISTRATION_PERIODS_SEGMENT}`;
}

export function getRegistrationPeriodLink(companyId: string, registrationPeriodId: string): string {
    return `${getRegistrationPeriodsLink(companyId)}/${registrationPeriodId}`;
}
